import React from "react";
import { Collapse, Form } from "react-bootstrap";
import type { AdequacaoCicloHistoricoItem } from "../../../../Analysis/V2/buildAnaliseCamposPorSecaoId";
import { formatDateTimeBR } from "../../../../../../utils/date";

export type AdequacaoHistoricoCiclosProps = {
  secaoId: string;
  ciclos: AdequacaoCicloHistoricoItem[];
  open: boolean;
  onToggle: () => void;
};


export default function AdequacaoHistoricoCiclos({
  secaoId,
  ciclos,
  open,
  onToggle,
}: AdequacaoHistoricoCiclosProps) {
  if (ciclos.length === 0) return null;

  return (
    <div className="mb-4" data-testid={`adequacao-historico-${secaoId}`}>
      <button
        type="button"
        className="p-0 border-0 bg-transparent text-primary text-decoration-underline small fw-semibold"
        onClick={onToggle}
        aria-expanded={open}
        aria-controls={`adequacao-historico-body-${secaoId}`}
      >
        {open
          ? "Ocultar histórico de solicitação de adequação"
          : "Exibir histórico de solicitação de adequação"}
      </button>
      <Collapse in={open}>
        <div id={`adequacao-historico-body-${secaoId}`} className="mt-3">
          {ciclos.map((ciclo, idx) => (
            <div
              key={`${String(ciclo.id)}-${idx}`}
              className="p-3 rounded border bg-light mb-3 shipping-analise-historico-ciclo"
            >
              <div className="small text-uppercase text-muted fw-bold mb-3">
                Adequação {idx + 1}
              </div>
              <Form.Group className="mb-2">
                <Form.Label className="small text-muted mb-0">
                  Observação analista
                </Form.Label>
                <Form.Control
                  as="textarea"
                  rows={2}
                  readOnly
                  className="bg-white"
                  value={ciclo.observacaoAnalista ?? ""}
                />
              </Form.Group>
              {ciclo.solicitadoEm ? (
                <div className="small text-muted text-end mb-3">
                  Solicitado em: {formatDateTimeBR(ciclo.solicitadoEm)}
                </div>
              ) : null}
              <Form.Group className="mb-0">
                <Form.Label className="small text-muted mb-0">
                  Observação sindicato
                </Form.Label>
                <Form.Control
                  as="textarea"
                  rows={2}
                  readOnly
                  className="bg-white"
                  value={ciclo.observacaoSindicato ?? ""}
                />
              </Form.Group>
              {ciclo.adequadoEm ? (
                <div className="small text-muted text-end mt-2">
                  Adequado em: {formatDateTimeBR(ciclo.adequadoEm)}
                </div>
              ) : (
                <div className="small text-muted text-end mt-2">
                  Aguardando retorno do sindicato neste ciclo.
                </div>
              )}
            </div>
          ))}
        </div>
      </Collapse>
    </div>
  );
}
